import React from 'react';
import { C } from '../../shared/design-tokens.js';

export const CONTROL_INPUT: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: 8,
  border: `1px solid ${C.borderSoft}`,
  background: 'rgba(7, 11, 18, 0.72)',
  color: C.text,
  fontSize: 14,
  boxSizing: 'border-box',
};

export const MUTED_LABEL: React.CSSProperties = {
  display: 'block',
  color: C.textMuted,
  fontSize: 12,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 6,
};

export function vehicleStatusPresentation(status: string) {
  switch (status) {
    case 'active':   return { label: 'Active',         color: C.green, background: 'rgba(78,205,196,0.12)' };
    case 'oos':      return { label: 'Out of Service',  color: C.red,   background: 'rgba(255,107,107,0.12)' };
    case 'in_transit': return { label: 'In Transit',   color: C.gold,  background: 'rgba(201,162,39,0.12)' };
    case 'returned': return { label: 'Returned',        color: C.textMuted, background: 'rgba(255,255,255,0.05)' };
    default:         return { label: status || 'Unknown', color: C.textMuted, background: 'rgba(255,255,255,0.05)' };
  }
}

export function leaseTypeLabel(leaseType: string | null | undefined): string {
  switch (leaseType) {
    case 'rental':  return 'Rental';
    case 'owned':   return 'Owned';
    case 'leased':  return 'Leased';
    default:        return leaseType || '\u2014';
  }
}
